import { render, staticRenderFns } from "./HoldTxnDetails.vue?vue&type=template&id=d0fb37b6&scoped=true"
import script from "./HoldTxnDetails.vue?vue&type=script&lang=js"
export * from "./HoldTxnDetails.vue?vue&type=script&lang=js"
import style0 from "./HoldTxnDetails.vue?vue&type=style&index=0&id=d0fb37b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fb37b6",
  null
  
)

export default component.exports